export const applyExpenseFeeFrequencyRules = (
  form = {},
  nextValue = '',
  firstInstallmentOptions = []
) => {
  const frequency = String(nextValue || '').trim().toLowerCase();

  if (frequency === 'unique') {
    form.expensesCount = 1;
    form.firstInstallmentOption = null;
    form.periodicityOption = null;
    return;
  }

  if (frequency === 'monthly') {
    form.periodicityOption = null;

    const options = Array.isArray(firstInstallmentOptions) ? firstInstallmentOptions : [];
    const currentValue = String(form?.firstInstallmentOption?.value || '').trim();
    const hasCurrent = options.some((option) => String(option?.value || '').trim() === currentValue);

    if (!hasCurrent) {
      const now = new Date();
      const month = `${now.getMonth() + 1}`.padStart(2, '0');
      const yearMonth = `${now.getFullYear()}-${month}`;
      const currentMonthOption = options.find((option) => String(option?.value || '').trim() === yearMonth);
      form.firstInstallmentOption = currentMonthOption || options[0] || null;
    }

    return;
  }

  if (frequency === 'multiple') {
    form.firstInstallmentOption = null;
  }
};
